import type * as React from 'react';
import { cn } from '@/lib/utils';
import { iconRegistry } from '@/ui/icons/registry';

// shadcn/ui (AD #39): shadcn's Spinner, adapted to the CRM's rules — its glyph comes from the icon registry
// (`spinner`, lucide's `LoaderCircle`, the glyph shadcn's own Spinner draws), the one module allowed to import
// lucide-react (FS-3 AC-21). It turns only when motion is allowed. Standing alone it is a `status` named
// *Loading*; inside a control that already says it is busy (a `Button` with `aria-busy`), pass `aria-hidden`,
// and it is drawn only, with no role or name of its own.
const Glyph = iconRegistry.spinner;

function Spinner({ className, ...props }: React.ComponentProps<'svg'>) {
    const hidden = props['aria-hidden'] === true || props['aria-hidden'] === 'true';
    return (
        <Glyph
            /* testid-exempt: a shadcn primitive; the caller passes data-testid through props */
            {...(hidden ? {} : { role: 'status', 'aria-label': 'Loading' })}
            data-slot="spinner"
            className={cn('size-4 animate-spin motion-reduce:animate-none', className)}
            {...props}
        />
    );
}

export { Spinner };
